import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AdministrativeConsolidatedSchedulesTransferService {
  private readonly baseUrl = `${environment.api_v2}/v2/administrative/financial`;

  constructor(private readonly http: HttpClient) {}

  transferSingle(consolidatedScheduleId: string): Observable<void> {
    const url = `${this.baseUrl}/previdas-transfer`;
    return this.http.post<void>(url, { consolidationId: consolidatedScheduleId });
  }

  batchTransfer(consolidatedScheduleIds: string[]): Observable<void> {
    const url = `${this.baseUrl}/previdas-transfer/batch`;
    return this.http.post<void>(url, { consolidationIds: consolidatedScheduleIds });
  }

  transferUnavailable(consolidatedScheduleId: string, observation: string): Observable<void> {
    const url = `${this.baseUrl}/previdas-transfer`;
    return this.http.post<void>(url, {
      consolidationId: consolidatedScheduleId,
      notes: observation,
    });
  }

  scheduleNFSe(transferId: string) {
    const url = `${this.baseUrl}/transfer/${transferId}/nfse`;
    return this.http.post<{ success: boolean }>(url, {}).pipe(take(1));
  }

  syncInvoice(invoiceId: string) {
    const url = `${this.baseUrl}/invoice/${invoiceId}/nfse`;
    return this.http.post<void>(url, {}).pipe(take(1));
  }
}
